import { useLocation, useNavigate } from "react-router-dom";
import { BoxTabs } from "../../../../components/AntdTab/AntdTab";
import Attendees from "../../Attendees/Attendees";
import Group from "./Group/Group";
import GuestList from "./GuestList/GuestList";
import Menu from "./Menu/Menu";
import Seating from "./Seating/Seating";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useDispatch } from "react-redux";
import { useEffect } from "react";


const items = [
  {
    key: "1",
    label: "Guest List",
    children: <GuestList/>,
  },
  {
    key: "2",
    label: "Attendees",
    children: <Attendees />,
  },
  {
    key: "3",
    label: "Seating",
    children: <Seating />,
  },
  {
    key: "4",
    label: "Menu",
    children: <Menu />,
  },
  {
    key: "5",
    label: "Group",
    children: <Group />,
  },
];


const Guests = () => {
  // const [selectedTab, setSelectedTab] = useState(tabLinks[0].title);
  // const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventMiddleware.getEventDetails({ id: state?.eventData?.id }));
  }, []);

  // console.log(state?.activeKey);

  // console.log(state?.activeKey);

  return (
    <>
      {/* <Row>
        <Tabs
          tabLinks={tabLinks}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          changeTitle={true}
        />
      </Row> */}
      <BoxTabs
        items={items}
        changeHeaderOnTab={true}
        activeKey={state?.activeKey}
        destroyOnBlur
      />
    </>
  );
};

export default Guests;
